module.exports = ".pointer-cursor {\n  cursor: pointer; }\n\n.text-secondary {\n  color: #c8ced3 !important; }\n\n.no-border-top {\n  border-top: 0px; }\n\n.center-text {\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/business-operations/business-operations-search-results.component.scss
// module id = ./src/app/business-operations/business-operations-search-results.component.scss
// module chunks = main